import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import axiosInstance from '../../../../hooks/axiosInstance';
import Pusher from 'pusher-js';

export default function ViewOrderApproval({
  showView,
  closeModal,
  refreshPage,
  order,
}) {
  const [orderList, setOrderList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userTypeId, setUserTypeId] = useState(null);
  const [bankOptions, setBankOptions] = useState([]); // State to hold bank options
  const [selectedBanks, setSelectedBanks] = useState({}); // Store selected banks by order code
  const [statuses, setStatuses] = useState({}); // Store selected statuses by order ID

  const handleClose = () => {
    closeModal();
  };

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserTypeId(userData?.user?.user_type_id);
    } else {
      console.log("No user data found");
    }
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      if (order) {
        try {
          const response = await axiosInstance.get("/user/order/get_order_no_paginate", {
            params: {
              order_code: order.order_code, // Fetch orders with the same order_code
            },
          });
          setOrderList(response.data.data.orders);
          
          // Initialize statuses for the fetched orders
          const initialStatuses = response.data.data.orders.reduce((acc, orderInfo) => {
            acc[orderInfo.order_code] = ''; // Use order_code instead of order_id
            return acc;
          }, {});
          setStatuses(initialStatuses);
        } catch (error) {
          console.error("Error fetching orders:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchOrders();
  }, [order]);

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await axiosInstance.get("/user/bank_account/get_account"); // Replace with your actual endpoint to fetch banks
        setBankOptions(response.data.data.accounts || []);
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };

    fetchBanks();
  }, []);

  const handleBankChange = (index, event) => {
    const selectedBank = event.target.value;
    setSelectedBanks(prevBanks => ({
      ...prevBanks,
      [index]: selectedBank,
    }));
  };

  const handleStatusChange = (index, newStatus) => {
    setStatuses(prevStatuses => ({
      ...prevStatuses,
      [index]: newStatus,
    }));
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    try {
      const ordersArray = orderList.map((orderInfo, index) => {
        const orderPayload = {
          warehouse_id: order.ware_house_id,
          order_id: orderInfo.id,
          order_code: orderInfo.order_code,
          customer_id: orderInfo.customer_id,
          company_id: orderInfo.company_detail_id,
          payment_type: orderInfo.payment_type,
          action: statuses[index], // Use the index to get the status
          bank_account_id: parseInt(selectedBanks[index], 10), // Use the index to get the selected bank
        };

        if (orderInfo.payment_type === 'cash' && selectedBanks[index]) {
          orderPayload.bank_account_id = parseInt(selectedBanks[index], 10); // Convert selected bank to a number
          orderPayload.action = statuses[index] || 'approved';
          orderPayload.customer_id = orderInfo.customer_id;
          orderPayload.company_id = orderInfo.company_detail_id;
        }
        // Check if payment type is cash and if there's a selected bank

        return orderPayload;

      });

      const apiUrl = '/user/requisition/approve_order';
      const response = await axiosInstance.post(apiUrl, { orders: ordersArray }); // Send as a JSON object

      toast.success("Orders processed successfully!");
      window.location.reload(); 
      handleClose();
    } catch (error) {
      console.error("Error processing orders:", error);
      // toast.error("An error occurred while processing the orders.");
    }
    finally {
      setIsLoading(false);
    }
  };


  const capitalize = (text) => {
    if (!text) return "";
    return text
      .replace("_", " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const orderDetails = orderList.length > 0 ? (
    orderList && orderList.map((orderInfo, index) => (
      
      <Card className="mb-3" key={index}>
        <Card.Body>
          <strong>Company Name:</strong> {orderInfo?.company_name}
          <br />
          <strong>Product Name:</strong> {orderInfo?.product_name}
          <br />
          <strong>Category:</strong> {orderInfo?.category_name}
          <br />
          <strong>Sub-Category:</strong> {orderInfo?.sub_category_name}
          <br />
          <strong>Price:</strong> {orderInfo?.price}
          <br />
          <strong>Quantity:</strong> {orderInfo?.quantity}
          <br />
          <strong>Total Price:</strong> {orderInfo?.total_price}
          <br />
          <strong>Payment Type:</strong> {orderInfo?.payment_type && orderInfo?.payment_type === "cash" ? "Cash/Prepaid" : orderInfo?.payment_type}

          <br />
          <strong>Sales-Supervisor Status:</strong>{" "}
          {orderInfo.status === "active" ? (
            <span className="badge bg-success">{orderInfo.status}</span>
          ) : (
            <span className="badge bg-info">{orderInfo.status}</span>
          )}
          <br />

          {["finance", "chain_supply"].map((role, index) => {
            // find the first approved record for this role
            const record = orderInfo.requisitions?.find(
              (req) =>
                req.approved_as === role &&
                req.status !== "pending" &&
                req.approved_by
            );

            return (
              <div key={index}>
                <span>
                  {capitalize(role)}:{" "}
                  {record
                    ? `${record.approved_by.first_name} ${record.approved_by.last_name}`
                    : ""}
                </span>{" "}
                {record ? (
                  <span className="badge bg-success">Approved</span>
                ) : (
                  <span className="badge bg-warning text-dark">Pending</span>
                )}
              </div>
            );
          })}
          <br />
          {/* <strong className=''>Approved as:</strong>
          <span
            className={`badge ${orderInfo?.approved_as === 'rejected' ? 'bg-danger' : 'bg-primary'
              }`}
          >
            {orderInfo?.approved_as}
          </span> */}
          
          {/* <strong className=''>Status:</strong><span className='badge bg-primary'>{orderInfo?.approved_as}</span> */}
          {/* <br /> <br /> */}

          {/* Status selection for the order */}
          {(((orderInfo.payment_type === 'transfer' || orderInfo.payment_type === 'credit') || (userTypeId === 10 || userTypeId === 1 || userTypeId === 2))) ? (
            <div className="mt-2">
              <strong>Status:</strong>
              <select
                className="form-select"
                value={statuses[index] || ''} // Use order_code here
                onChange={(e) => handleStatusChange(index, e.target.value)} // Ensure target.value is used
              >
                <option value="">Select Status</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
                {/* Add more status options if needed */}
              </select>
            </div>
          ) : null}

          {userTypeId === 4 && orderInfo.payment_type === 'cash' ? (
            <div className="mt-2">
              <strong>Select Bank:</strong>
              <select
                className="form-select"
                value={selectedBanks[index] || ''} // Use order_code here
                onChange={(e) => handleBankChange(index, e)} // Handle bank selection
              >
                <option value="">Select Bank</option>
                {bankOptions.map((bank) => (
                  <option key={bank.id} value={bank.id}>{bank.bank}</option> // Assuming bank has id and name
                ))}
              </select>
            </div>
          ) : null}
        </Card.Body>
      </Card>
    ))
  ) : (
    <p>No order details available.</p>
  );

  return (
    <div className="ViewTransaction">
      <ToastContainer />
      <Modal show={showView} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Order Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "15px", lineHeight: "30px" }}>{orderDetails}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button> */}
          <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? "submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}